<template>
  <section class="page-relatorio-detalhe-fonte-pagadora">
    <div class="container container-md container-header-relatorio">
      <div class="row relatorio-recebimento-header">
        <div class="col-2">
          <v-btn flat icon color="primary" @click.stop="back">
            <v-icon dark>keyboard_backspace</v-icon>
          </v-btn>
        </div>
        <div class="col-10 col-md-8">
          <h6 class="relatorio-recebimento-fonte-pagadora">{{ title }}</h6>
        </div>
        <div class="col-2 d-none d-md-block text-right">
          <v-btn flat large icon color="primary" @click.stop="print">
            <v-icon dark>print</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="container container-md container-full-xs">
      <div class="row">
        <div class="col-12">
          <template v-for="agrupamentoDia in producao">
            <v-card :key="agrupamentoDia.dataRealizacao.getTime()" class="mb-5 list-card">
              <v-toolbar flat>
                <v-toolbar-title>
                  <div class="row">
                    <div class="col-6 col-md-9">
                      <b>{{ formatarData(agrupamentoDia.dataRealizacao) }}</b>
                    </div>
                    <div class="col-3 d-block d-md-none text-right">Quant.</div>
                    <div class="col-3 text-right">Valor</div>
                  </div>
                </v-toolbar-title>
              </v-toolbar>
              <v-divider></v-divider>
              <v-card-text v-for="producao in agrupamentoDia.producao" :key="producao.identificador">
                <div class="row row-col-fit-xs">
                  <div class="col-7 col-md-12">
                    <h6 class="font-weight-bold">{{ producao.nomePaciente }}</h6>
                    <p class="mb-2  "><span>{{`${producao.fontePagadora.nome} • ${producao.operadora.nome}`}} <span v-if="producao.planoEmpresa">• {{ producao.planoEmpresa }}</span></span></p>
                  </div>
                  <div class="col-1 d-block d-md-none text-right">
                    <p><b>{{ formatarQuantidadeTotalPaciente(producao) }}</b></p>
                  </div>
                  <div class="col-4 d-block d-md-none text-right">
                    <p><b>{{ formatarValorTotalPaciente(producao) }}</b></p>
                  </div>
                </div>

                <div class="row row-col-fit-xs row-procedimento" v-for="procedimento in producao.procedimento" :key="procedimento.sequencial">
                  <div class="col-7 col-md-6">
                    <p class="mb-0 font-weight-bold">{{ descricaoProcedimento(procedimento) }}</p>
                  </div>
                  <div class="col-1 col-md-3 text-right">
                    <p class="mb-0 d-none d-md-block">Quant: {{ formatarQuantidade(procedimento.quantidade) }}</p>
                    <p class="mb-0 d-block d-md-none">{{ formatarQuantidade(procedimento.quantidade) }}</p>
                  </div>
                  <div class="col-4 col-md-3 text-right">
                    <p class="mb-0">{{ formatarValor(procedimento.valorTotal) }}</p>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import Moment from 'moment'
import Timezone from 'moment-timezone'

import { NumberMixin, DateMixin } from '@finx/web-repository/src/mixin/_'

import ApiLegacy from '@finx/web-repository/src/apis/Legacy/Legacy'

export default {
  name: 'relatorio-detalhe-fonte-pagadora',
  mixins: [DateMixin, NumberMixin],
  components: {},
  data() {
    return {
      producao: null,
    }
  },
  computed: {
    title() {
      if (this.producao == null) return ''
      return `${this.producao[0].producao[0].fontePagadora.nome} / ${this.producao[0].producao[0].operadora.nome}`
    },
  },
  methods: {
    print() {
      window.print()
    },
    back() {
      window.history.back()
    },
    formatarQuantidadeTotalPaciente(producao) {
      return _.padStart(_.sumBy(producao.procedimento, 'quantidade'), 2, '0')
    },
    formatarValorTotalPaciente(producao) {
      return `R$ ${this.formatDecimalNumber(_.sumBy(producao.procedimento, 'valorTotal'), 2, '.', ',')}`
    },
    formatarQuantidade(value) {
      return _.padStart(value, 2, '0')
    },
    formatarValor(valor) {
      return `R$ ${this.formatDecimalNumber(valor, 2, '.', ',')}`
    },
    descricaoProcedimento(procedimento) {
      if (procedimento.tabelaPrecoProcedimento.descricao.length > 60) return `${procedimento.tabelaPrecoProcedimento.codigoUnico} - ${procedimento.tabelaPrecoProcedimento.descricao.substring(0, 60)}...`
      return `${procedimento.tabelaPrecoProcedimento.codigoUnico} - ${procedimento.tabelaPrecoProcedimento.descricao}`
    },
    formatarData(data) {
      return Moment(data).locale('pt-br').format('DD/MM/YYYY')
    },
  },
  created() {
    const that = this

    that.emailState = that.passwordState = null
    ApiLegacy.Relatorios.listarDetalhePorFontePagadora(
      this.$route.params.idFontePagadora,
      this.$route.params.idOperadora,
      this.$route.params.dataInicial,
      this.$route.params.dataFinal,
    ).then(
      (response) => {
        that.producao = null
        if (response.data.success) {
          let dataRealizacao = _.sortBy(response.data.data, 'dataRealizacao')
          dataRealizacao = _.groupBy(dataRealizacao, 'dataRealizacao')
          that.producao = _.map(dataRealizacao, (value, key) => ({
            dataRealizacao: new Date(value[0].dataRealizacao),
            producao: value,
          }))
        } else ModalStore.commit(MODAL_MUT_ERRO, result.error)
      },
    )
  },
}
</script>

<style lang="scss" scoped>
.container-header-relatorio {
  padding-bottom: 0
}

.relatorio-recebimento-header {
  @media(max-width: 767px) {
    margin-bottom: 30px !important;
  }
}

.relatorio-recebimento-fonte-pagadora {
  font-size: 20px;
  margin: 0;
  font-weight: 600;
  position: relative;
  top: 10px;
  margin-bottom: 15px;
}

.list-card {
  .v-toolbar__title {
    width: 100%;
  }

  .v-toolbar {
    background-color: $cl-dusk-blue;
  }

  .v-toolbar__title {
    color: #FFF
  }

  p {
    font-size: 12px;
  }
}

.container-full-xs {
  padding-top: 0;

  @media(max-width: 767px) {
    padding: 0
  }
}

.row-procedimento {
  padding: 10px 0;
  border-top: 1px solid $cl-very-light-blue;
}
</style>
